import React from 'react'

export default function AcademicPlanningBoard() {
    return (
        <div>AcademicPlanningBoard</div>
    )
}
